export default __webpack_public_path__ + "aa345f6746d7751a850fb313f04baf28.png";